import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const CustomSelect = ({
  labelId,
  id,
  selectValue,
  selectLabel,
  selectOnChange,
  menuItems,
}) => {

  return (
    <div className="form-builder-section-div">
      <Select
        labelId={labelId}
        id={id}
        value={selectValue}
        label={selectLabel}
        onChange={selectOnChange}
        sx={{
          width: "150px",
          background: "#eeeff1",
          border: "none", // Ensures no border
          ".MuiOutlinedInput-notchedOutline": {
            border: "none", // Removes the default border
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none", // Removes the border on focus
          },
          borderRadius: "15px", // Sets border-radius
          height: "45px",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none", // Ensures no border on hover
          },
          "& .MuiSelect-select": {
            borderRadius: "15px", // Applies border-radius to the select element
          },
          fontFamily: "Roboto",
          fontSize: "16px",
          // This is to remove the border on the actual input field inside the select dropdown.
          "& .MuiInputBase-input": {
            borderRadius: "15px",
          },
        }}
      >
        {menuItems &&
          menuItems.map((item, index) => (
            <MenuItem key={index} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default CustomSelect;
